import { portalApiBaseUrl } from "../config";

export const graphqlEndpoint = `${portalApiBaseUrl}/graphql`;
